import React from "react";
import { BadgeCheck, ShieldCheck, FileCheck2 } from "lucide-react";

export default function VerifiedBar() {
  return (
    <section className="relative py-6 bg-white border-y border-brand-gold/20" data-testid="verified-bar">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="flex flex-col md:flex-row items-center justify-center gap-5 md:gap-10 text-center md:text-right">
          {/* Main MoC verification */}
          <div className="flex items-center gap-3" data-testid="moc-verified-badge">
            <div className="relative shrink-0">
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-brand-green to-brand-green-light flex items-center justify-center shadow-lg ring-2 ring-brand-gold/40">
                <BadgeCheck className="w-8 h-8 text-brand-gold-light" />
              </div>
              <span className="absolute -top-1 -end-1 w-5 h-5 rounded-full bg-green-500 ring-2 ring-white flex items-center justify-center">
                <svg viewBox="0 0 24 24" className="w-3 h-3 text-white" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </span>
            </div>
            <div>
              <div className="text-xs font-bold text-brand-gold tracking-widest uppercase">علامة التوثيق</div>
              <div className="font-heading font-extrabold text-brand-green text-base md:text-lg leading-tight">
                موقع موثّق من وزارة التجارة
              </div>
              <div className="text-xs text-brand-ink/60 mt-0.5">المملكة العربية السعودية</div>
            </div>
          </div>

          <div className="hidden md:block h-14 w-px bg-brand-gold/25" />

          {/* Secondary trust badges */}
          <div className="flex items-center gap-5 md:gap-7">
            <div className="flex items-center gap-2">
              <ShieldCheck className="w-5 h-5 text-brand-gold" />
              <span className="text-sm font-bold text-brand-ink/80">معاملات شرعية</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
